/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as UpdatePasswordRouteImport } from './routes/update-password'
import { Route as UnauthorizedRouteImport } from './routes/unauthorized'
import { Route as SuperAdminRouteImport } from './routes/super-admin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as NoOrganizationRouteImport } from './routes/no-organization'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuperAdminIndexRouteImport } from './routes/super-admin/index'
import { Route as AuthImpersonateRouteImport } from './routes/auth/impersonate'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedScheduleRouteImport } from './routes/_authenticated/schedule'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedInsightsRouteImport } from './routes/_authenticated/insights'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as SuperAdminUsersIndexRouteImport } from './routes/super-admin/users/index'
import { Route as SuperAdminSuperAdminsIndexRouteImport } from './routes/super-admin/super-admins/index'
import { Route as SuperAdminSettingsIndexRouteImport } from './routes/super-admin/settings/index'
import { Route as SuperAdminPlansIndexRouteImport } from './routes/super-admin/plans/index'
import { Route as SuperAdminOrganizationsIndexRouteImport } from './routes/super-admin/organizations/index'
import { Route as SuperAdminMetaWhatsappIndexRouteImport } from './routes/super-admin/meta-whatsapp/index'
import { Route as SuperAdminMaintenanceIndexRouteImport } from './routes/super-admin/maintenance/index'
import { Route as SuperAdminBillingIndexRouteImport } from './routes/super-admin/billing/index'
import { Route as SuperAdminAuditLogsIndexRouteImport } from './routes/super-admin/audit-logs/index'
import { Route as SuperAdminAlertsIndexRouteImport } from './routes/super-admin/alerts/index'
import { Route as AuthenticatedPatientsIndexRouteImport } from './routes/_authenticated/patients/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as SuperAdminOrganizationsOrgIdRouteImport } from './routes/super-admin/organizations/$orgId'
import { Route as AuthenticatedPatientsPatientIdRouteImport } from './routes/_authenticated/patients/$patientId'
import { Route as AuthenticatedAdminSettingsRouteImport } from './routes/_authenticated/admin/settings'
import { Route as AuthenticatedAdminProfessionalsRouteImport } from './routes/_authenticated/admin/professionals'
import { Route as AuthenticatedAdminPatientsRouteImport } from './routes/_authenticated/admin/patients'
import { Route as AuthenticatedAdminAnalyticsRouteImport } from './routes/_authenticated/admin/analytics'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
  id: '/update-password',
  path: '/update-password',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthorizedRoute = UnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperAdminRoute = SuperAdminRouteImport.update({
  id: '/super-admin',
  path: '/super-admin',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const NoOrganizationRoute = NoOrganizationRouteImport.update({
  id: '/no-organization',
  path: '/no-organization',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperAdminIndexRoute = SuperAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperAdminRoute,
} as any)
const AuthImpersonateRoute = AuthImpersonateRouteImport.update({
  id: '/auth/impersonate',
  path: '/auth/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedScheduleRoute = AuthenticatedScheduleRouteImport.update({
  id: '/schedule',
  path: '/schedule',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedInsightsRoute = AuthenticatedInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const SuperAdminUsersIndexRoute = SuperAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => SuperAdminRoute,
} as any)
const SuperAdminSuperAdminsIndexRoute =
  SuperAdminSuperAdminsIndexRouteImport.update({
    id: '/super-admins/',
    path: '/super-admins/',
    getParentRoute: () => SuperAdminRoute,
  } as any)
const SuperAdminSettingsIndexRoute = SuperAdminSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => SuperAdminRoute,
} as any)
const SuperAdminPlansIndexRoute = SuperAdminPlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => SuperAdminRoute,
} as any)
const SuperAdminOrganizationsIndexRoute =
  SuperAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => SuperAdminRoute,
  } as any)
const SuperAdminMetaWhatsappIndexRoute =
  SuperAdminMetaWhatsappIndexRouteImport.update({
    id: '/meta-whatsapp/',
    path: '/meta-whatsapp/',
    getParentRoute: () => SuperAdminRoute,
  } as any)
const SuperAdminMaintenanceIndexRoute =
  SuperAdminMaintenanceIndexRouteImport.update({
    id: '/maintenance/',
    path: '/maintenance/',
    getParentRoute: () => SuperAdminRoute,
  } as any)
const SuperAdminBillingIndexRoute = SuperAdminBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => SuperAdminRoute,
} as any)
const SuperAdminAuditLogsIndexRoute =
  SuperAdminAuditLogsIndexRouteImport.update({
    id: '/audit-logs/',
    path: '/audit-logs/',
    getParentRoute: () => SuperAdminRoute,
  } as any)
const SuperAdminAlertsIndexRoute = SuperAdminAlertsIndexRouteImport.update({
  id: '/alerts/',
  path: '/alerts/',
  getParentRoute: () => SuperAdminRoute,
} as any)
const AuthenticatedPatientsIndexRoute =
  AuthenticatedPatientsIndexRouteImport.update({
    id: '/patients/',
    path: '/patients/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const SuperAdminOrganizationsOrgIdRoute =
  SuperAdminOrganizationsOrgIdRouteImport.update({
    id: '/organizations/$orgId',
    path: '/organizations/$orgId',
    getParentRoute: () => SuperAdminRoute,
  } as any)
const AuthenticatedPatientsPatientIdRoute =
  AuthenticatedPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminSettingsRoute =
  AuthenticatedAdminSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminProfessionalsRoute =
  AuthenticatedAdminProfessionalsRouteImport.update({
    id: '/professionals',
    path: '/professionals',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPatientsRoute =
  AuthenticatedAdminPatientsRouteImport.update({
    id: '/patients',
    path: '/patients',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminAnalyticsRoute =
  AuthenticatedAdminAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-organization': typeof NoOrganizationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/super-admin': typeof SuperAdminRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/update-password': typeof UpdatePasswordRoute
  '/welcome': typeof WelcomeRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/insights': typeof AuthenticatedInsightsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/schedule': typeof AuthenticatedScheduleRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/auth/impersonate': typeof AuthImpersonateRoute
  '/super-admin/': typeof SuperAdminIndexRoute
  '/admin/analytics': typeof AuthenticatedAdminAnalyticsRoute
  '/admin/patients': typeof AuthenticatedAdminPatientsRoute
  '/admin/professionals': typeof AuthenticatedAdminProfessionalsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/super-admin/organizations/$orgId': typeof SuperAdminOrganizationsOrgIdRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/patients/': typeof AuthenticatedPatientsIndexRoute
  '/super-admin/alerts/': typeof SuperAdminAlertsIndexRoute
  '/super-admin/audit-logs/': typeof SuperAdminAuditLogsIndexRoute
  '/super-admin/billing/': typeof SuperAdminBillingIndexRoute
  '/super-admin/maintenance/': typeof SuperAdminMaintenanceIndexRoute
  '/super-admin/meta-whatsapp/': typeof SuperAdminMetaWhatsappIndexRoute
  '/super-admin/organizations/': typeof SuperAdminOrganizationsIndexRoute
  '/super-admin/plans/': typeof SuperAdminPlansIndexRoute
  '/super-admin/settings/': typeof SuperAdminSettingsIndexRoute
  '/super-admin/super-admins/': typeof SuperAdminSuperAdminsIndexRoute
  '/super-admin/users/': typeof SuperAdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/no-organization': typeof NoOrganizationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/update-password': typeof UpdatePasswordRoute
  '/welcome': typeof WelcomeRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/insights': typeof AuthenticatedInsightsRoute
  '/reports': typeof AuthenticatedReportsRoute
  '/schedule': typeof AuthenticatedScheduleRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/auth/impersonate': typeof AuthImpersonateRoute
  '/super-admin': typeof SuperAdminIndexRoute
  '/admin/analytics': typeof AuthenticatedAdminAnalyticsRoute
  '/admin/patients': typeof AuthenticatedAdminPatientsRoute
  '/admin/professionals': typeof AuthenticatedAdminProfessionalsRoute
  '/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/super-admin/organizations/$orgId': typeof SuperAdminOrganizationsOrgIdRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/patients': typeof AuthenticatedPatientsIndexRoute
  '/super-admin/alerts': typeof SuperAdminAlertsIndexRoute
  '/super-admin/audit-logs': typeof SuperAdminAuditLogsIndexRoute
  '/super-admin/billing': typeof SuperAdminBillingIndexRoute
  '/super-admin/maintenance': typeof SuperAdminMaintenanceIndexRoute
  '/super-admin/meta-whatsapp': typeof SuperAdminMetaWhatsappIndexRoute
  '/super-admin/organizations': typeof SuperAdminOrganizationsIndexRoute
  '/super-admin/plans': typeof SuperAdminPlansIndexRoute
  '/super-admin/settings': typeof SuperAdminSettingsIndexRoute
  '/super-admin/super-admins': typeof SuperAdminSuperAdminsIndexRoute
  '/super-admin/users': typeof SuperAdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/no-organization': typeof NoOrganizationRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/super-admin': typeof SuperAdminRouteWithChildren
  '/unauthorized': typeof UnauthorizedRoute
  '/update-password': typeof UpdatePasswordRoute
  '/welcome': typeof WelcomeRoute
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/insights': typeof AuthenticatedInsightsRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRoute
  '/_authenticated/schedule': typeof AuthenticatedScheduleRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/auth/impersonate': typeof AuthImpersonateRoute
  '/super-admin/': typeof SuperAdminIndexRoute
  '/_authenticated/admin/analytics': typeof AuthenticatedAdminAnalyticsRoute
  '/_authenticated/admin/patients': typeof AuthenticatedAdminPatientsRoute
  '/_authenticated/admin/professionals': typeof AuthenticatedAdminProfessionalsRoute
  '/_authenticated/admin/settings': typeof AuthenticatedAdminSettingsRoute
  '/_authenticated/patients/$patientId': typeof AuthenticatedPatientsPatientIdRoute
  '/super-admin/organizations/$orgId': typeof SuperAdminOrganizationsOrgIdRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/patients/': typeof AuthenticatedPatientsIndexRoute
  '/super-admin/alerts/': typeof SuperAdminAlertsIndexRoute
  '/super-admin/audit-logs/': typeof SuperAdminAuditLogsIndexRoute
  '/super-admin/billing/': typeof SuperAdminBillingIndexRoute
  '/super-admin/maintenance/': typeof SuperAdminMaintenanceIndexRoute
  '/super-admin/meta-whatsapp/': typeof SuperAdminMetaWhatsappIndexRoute
  '/super-admin/organizations/': typeof SuperAdminOrganizationsIndexRoute
  '/super-admin/plans/': typeof SuperAdminPlansIndexRoute
  '/super-admin/settings/': typeof SuperAdminSettingsIndexRoute
  '/super-admin/super-admins/': typeof SuperAdminSuperAdminsIndexRoute
  '/super-admin/users/': typeof SuperAdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/no-organization'
    | '/reset-password'
    | '/signup'
    | '/super-admin'
    | '/unauthorized'
    | '/update-password'
    | '/welcome'
    | '/admin'
    | '/dashboard'
    | '/insights'
    | '/reports'
    | '/schedule'
    | '/settings'
    | '/auth/impersonate'
    | '/super-admin/'
    | '/admin/analytics'
    | '/admin/patients'
    | '/admin/professionals'
    | '/admin/settings'
    | '/patients/$patientId'
    | '/super-admin/organizations/$orgId'
    | '/admin/'
    | '/patients/'
    | '/super-admin/alerts/'
    | '/super-admin/audit-logs/'
    | '/super-admin/billing/'
    | '/super-admin/maintenance/'
    | '/super-admin/meta-whatsapp/'
    | '/super-admin/organizations/'
    | '/super-admin/plans/'
    | '/super-admin/settings/'
    | '/super-admin/super-admins/'
    | '/super-admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/no-organization'
    | '/reset-password'
    | '/signup'
    | '/unauthorized'
    | '/update-password'
    | '/welcome'
    | '/dashboard'
    | '/insights'
    | '/reports'
    | '/schedule'
    | '/settings'
    | '/auth/impersonate'
    | '/super-admin'
    | '/admin/analytics'
    | '/admin/patients'
    | '/admin/professionals'
    | '/admin/settings'
    | '/patients/$patientId'
    | '/super-admin/organizations/$orgId'
    | '/admin'
    | '/patients'
    | '/super-admin/alerts'
    | '/super-admin/audit-logs'
    | '/super-admin/billing'
    | '/super-admin/maintenance'
    | '/super-admin/meta-whatsapp'
    | '/super-admin/organizations'
    | '/super-admin/plans'
    | '/super-admin/settings'
    | '/super-admin/super-admins'
    | '/super-admin/users'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/no-organization'
    | '/reset-password'
    | '/signup'
    | '/super-admin'
    | '/unauthorized'
    | '/update-password'
    | '/welcome'
    | '/_authenticated/admin'
    | '/_authenticated/dashboard'
    | '/_authenticated/insights'
    | '/_authenticated/reports'
    | '/_authenticated/schedule'
    | '/_authenticated/settings'
    | '/auth/impersonate'
    | '/super-admin/'
    | '/_authenticated/admin/analytics'
    | '/_authenticated/admin/patients'
    | '/_authenticated/admin/professionals'
    | '/_authenticated/admin/settings'
    | '/_authenticated/patients/$patientId'
    | '/super-admin/organizations/$orgId'
    | '/_authenticated/admin/'
    | '/_authenticated/patients/'
    | '/super-admin/alerts/'
    | '/super-admin/audit-logs/'
    | '/super-admin/billing/'
    | '/super-admin/maintenance/'
    | '/super-admin/meta-whatsapp/'
    | '/super-admin/organizations/'
    | '/super-admin/plans/'
    | '/super-admin/settings/'
    | '/super-admin/super-admins/'
    | '/super-admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  NoOrganizationRoute: typeof NoOrganizationRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  SuperAdminRoute: typeof SuperAdminRouteWithChildren
  UnauthorizedRoute: typeof UnauthorizedRoute
  UpdatePasswordRoute: typeof UpdatePasswordRoute
  WelcomeRoute: typeof WelcomeRoute
  AuthImpersonateRoute: typeof AuthImpersonateRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/update-password': {
      id: '/update-password'
      path: '/update-password'
      fullPath: '/update-password'
      preLoaderRoute: typeof UpdatePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/super-admin': {
      id: '/super-admin'
      path: '/super-admin'
      fullPath: '/super-admin'
      preLoaderRoute: typeof SuperAdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-organization': {
      id: '/no-organization'
      path: '/no-organization'
      fullPath: '/no-organization'
      preLoaderRoute: typeof NoOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/super-admin/': {
      id: '/super-admin/'
      path: '/'
      fullPath: '/super-admin/'
      preLoaderRoute: typeof SuperAdminIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/auth/impersonate': {
      id: '/auth/impersonate'
      path: '/auth/impersonate'
      fullPath: '/auth/impersonate'
      preLoaderRoute: typeof AuthImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/schedule': {
      id: '/_authenticated/schedule'
      path: '/schedule'
      fullPath: '/schedule'
      preLoaderRoute: typeof AuthenticatedScheduleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/insights': {
      id: '/_authenticated/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof AuthenticatedInsightsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/super-admin/users/': {
      id: '/super-admin/users/'
      path: '/users'
      fullPath: '/super-admin/users/'
      preLoaderRoute: typeof SuperAdminUsersIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/super-admins/': {
      id: '/super-admin/super-admins/'
      path: '/super-admins'
      fullPath: '/super-admin/super-admins/'
      preLoaderRoute: typeof SuperAdminSuperAdminsIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/settings/': {
      id: '/super-admin/settings/'
      path: '/settings'
      fullPath: '/super-admin/settings/'
      preLoaderRoute: typeof SuperAdminSettingsIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/plans/': {
      id: '/super-admin/plans/'
      path: '/plans'
      fullPath: '/super-admin/plans/'
      preLoaderRoute: typeof SuperAdminPlansIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/organizations/': {
      id: '/super-admin/organizations/'
      path: '/organizations'
      fullPath: '/super-admin/organizations/'
      preLoaderRoute: typeof SuperAdminOrganizationsIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/meta-whatsapp/': {
      id: '/super-admin/meta-whatsapp/'
      path: '/meta-whatsapp'
      fullPath: '/super-admin/meta-whatsapp/'
      preLoaderRoute: typeof SuperAdminMetaWhatsappIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/maintenance/': {
      id: '/super-admin/maintenance/'
      path: '/maintenance'
      fullPath: '/super-admin/maintenance/'
      preLoaderRoute: typeof SuperAdminMaintenanceIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/billing/': {
      id: '/super-admin/billing/'
      path: '/billing'
      fullPath: '/super-admin/billing/'
      preLoaderRoute: typeof SuperAdminBillingIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/audit-logs/': {
      id: '/super-admin/audit-logs/'
      path: '/audit-logs'
      fullPath: '/super-admin/audit-logs/'
      preLoaderRoute: typeof SuperAdminAuditLogsIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/super-admin/alerts/': {
      id: '/super-admin/alerts/'
      path: '/alerts'
      fullPath: '/super-admin/alerts/'
      preLoaderRoute: typeof SuperAdminAlertsIndexRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/_authenticated/patients/': {
      id: '/_authenticated/patients/'
      path: '/patients'
      fullPath: '/patients/'
      preLoaderRoute: typeof AuthenticatedPatientsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/super-admin/organizations/$orgId': {
      id: '/super-admin/organizations/$orgId'
      path: '/organizations/$orgId'
      fullPath: '/super-admin/organizations/$orgId'
      preLoaderRoute: typeof SuperAdminOrganizationsOrgIdRouteImport
      parentRoute: typeof SuperAdminRoute
    }
    '/_authenticated/patients/$patientId': {
      id: '/_authenticated/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/patients/$patientId'
      preLoaderRoute: typeof AuthenticatedPatientsPatientIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/settings': {
      id: '/_authenticated/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AuthenticatedAdminSettingsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/professionals': {
      id: '/_authenticated/admin/professionals'
      path: '/professionals'
      fullPath: '/admin/professionals'
      preLoaderRoute: typeof AuthenticatedAdminProfessionalsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/patients': {
      id: '/_authenticated/admin/patients'
      path: '/patients'
      fullPath: '/admin/patients'
      preLoaderRoute: typeof AuthenticatedAdminPatientsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/analytics': {
      id: '/_authenticated/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AuthenticatedAdminAnalyticsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminAnalyticsRoute: typeof AuthenticatedAdminAnalyticsRoute
  AuthenticatedAdminPatientsRoute: typeof AuthenticatedAdminPatientsRoute
  AuthenticatedAdminProfessionalsRoute: typeof AuthenticatedAdminProfessionalsRoute
  AuthenticatedAdminSettingsRoute: typeof AuthenticatedAdminSettingsRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminAnalyticsRoute: AuthenticatedAdminAnalyticsRoute,
  AuthenticatedAdminPatientsRoute: AuthenticatedAdminPatientsRoute,
  AuthenticatedAdminProfessionalsRoute: AuthenticatedAdminProfessionalsRoute,
  AuthenticatedAdminSettingsRoute: AuthenticatedAdminSettingsRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedInsightsRoute: typeof AuthenticatedInsightsRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRoute
  AuthenticatedScheduleRoute: typeof AuthenticatedScheduleRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedPatientsPatientIdRoute: typeof AuthenticatedPatientsPatientIdRoute
  AuthenticatedPatientsIndexRoute: typeof AuthenticatedPatientsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedInsightsRoute: AuthenticatedInsightsRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRoute,
  AuthenticatedScheduleRoute: AuthenticatedScheduleRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedPatientsPatientIdRoute: AuthenticatedPatientsPatientIdRoute,
  AuthenticatedPatientsIndexRoute: AuthenticatedPatientsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface SuperAdminRouteChildren {
  SuperAdminIndexRoute: typeof SuperAdminIndexRoute
  SuperAdminOrganizationsOrgIdRoute: typeof SuperAdminOrganizationsOrgIdRoute
  SuperAdminAlertsIndexRoute: typeof SuperAdminAlertsIndexRoute
  SuperAdminAuditLogsIndexRoute: typeof SuperAdminAuditLogsIndexRoute
  SuperAdminBillingIndexRoute: typeof SuperAdminBillingIndexRoute
  SuperAdminMaintenanceIndexRoute: typeof SuperAdminMaintenanceIndexRoute
  SuperAdminMetaWhatsappIndexRoute: typeof SuperAdminMetaWhatsappIndexRoute
  SuperAdminOrganizationsIndexRoute: typeof SuperAdminOrganizationsIndexRoute
  SuperAdminPlansIndexRoute: typeof SuperAdminPlansIndexRoute
  SuperAdminSettingsIndexRoute: typeof SuperAdminSettingsIndexRoute
  SuperAdminSuperAdminsIndexRoute: typeof SuperAdminSuperAdminsIndexRoute
  SuperAdminUsersIndexRoute: typeof SuperAdminUsersIndexRoute
}

const SuperAdminRouteChildren: SuperAdminRouteChildren = {
  SuperAdminIndexRoute: SuperAdminIndexRoute,
  SuperAdminOrganizationsOrgIdRoute: SuperAdminOrganizationsOrgIdRoute,
  SuperAdminAlertsIndexRoute: SuperAdminAlertsIndexRoute,
  SuperAdminAuditLogsIndexRoute: SuperAdminAuditLogsIndexRoute,
  SuperAdminBillingIndexRoute: SuperAdminBillingIndexRoute,
  SuperAdminMaintenanceIndexRoute: SuperAdminMaintenanceIndexRoute,
  SuperAdminMetaWhatsappIndexRoute: SuperAdminMetaWhatsappIndexRoute,
  SuperAdminOrganizationsIndexRoute: SuperAdminOrganizationsIndexRoute,
  SuperAdminPlansIndexRoute: SuperAdminPlansIndexRoute,
  SuperAdminSettingsIndexRoute: SuperAdminSettingsIndexRoute,
  SuperAdminSuperAdminsIndexRoute: SuperAdminSuperAdminsIndexRoute,
  SuperAdminUsersIndexRoute: SuperAdminUsersIndexRoute,
}

const SuperAdminRouteWithChildren = SuperAdminRoute._addFileChildren(
  SuperAdminRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  NoOrganizationRoute: NoOrganizationRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  SuperAdminRoute: SuperAdminRouteWithChildren,
  UnauthorizedRoute: UnauthorizedRoute,
  UpdatePasswordRoute: UpdatePasswordRoute,
  WelcomeRoute: WelcomeRoute,
  AuthImpersonateRoute: AuthImpersonateRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
